import React from 'react';
import styles from './Options.module.scss';

interface TermsAndConditionsProps {
  isExpiryJourney: boolean;
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({ isExpiryJourney }) => (
  <div className={styles.termsAndConditions} id="termsAndConditions">
    <b>Terms and conditions</b><br />
    {isExpiryJourney ? (
      <ol>
        <li>Reward redemption is subject to renewal of your breakdown cover.</li>
        <li>You can redeem this offer up to 60 days after your renewal date (or annual review date if you’re on a monthly contract).</li>
        <li>Only valid for this membership number.</li>
        <li>Your reward will begin on the date you choose to start your breakdown cover.</li>
        <li>Only one reward per membership and no cash alternative is available.</li>
        <li>Offer cannot be used in conjunction with any general, site-wide, or public promotions. However, the offer may be used with personalised offers.</li>
        <li>If the breakdown policy is cancelled or lapses before the end of your policy term, the reward will be as well.</li>
        <li>You will lose your reward if you change to one of the following policies: a business policy, one linked to your vehicle manufacturer or via Tesco.</li>
        <li>Your reward will expire at the end of the breakdown policy term.</li>
      </ol>
    ) : (
      <ol>
        <li>Reward redemption is subject to renewal of your breakdown cover.</li>
        <li>You can redeem this offer up to your renewal date (or annual review date if you’re on a monthly contract). If you’re a Direct Debit payer this is three days before.</li>
        <li>Only valid for this membership number.</li>
        <li>Your reward will start from your renewal date (or annual review date if you’re on a monthly contract)</li>
        <li>Only one reward per membership and no cash alternative is available.</li>
        <li>Offer cannot be used in conjunction with any other offer and can be withdrawn at any time.</li>
        <li>If the breakdown policy is cancelled or lapses before the end of your policy term, the reward will be as well</li>
        <li>You will lose your reward if you change to one of the following policies: a business policy, one linked to your vehicle manufacturer or via Tesco</li>
        <li>Your reward will expire at the end of the breakdown policy term</li>
      </ol>
    )}
  </div>
);

export default TermsAndConditions;
